import styled from 'styled-components'
import { typoHeading2, typoParagraph } from '../../lib/styles/Typography'

export const StyledDisturber = styled.div`
  margin: 5rem auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background-color: var(--c-theme-3);
  border-radius: 1.5rem;
  padding: 2.5rem 3rem;

  @media screen and (max-width: 768px) {
    padding: 2rem;
  }
`

export const StyledBodyMain = styled.div`
  color: var(--c-theme-invert);
`

export const StyledHeadline = styled.h2`
  ${typoHeading2}
  margin-bottom: 0.5rem;

  @media screen and (max-width: 768px) {
  }
`

export const StyledDescription = styled.div`
  ${typoParagraph}
`

export const StyledButtons = styled.div`
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
`
